import type { CSSProperties, SVGProps } from 'react';
import claudeCodeSrc from './claude-code.svg?url';

/** Drop-in icon component for the Claude Code brand mark. */
export function ClaudeCodeIcon({ className, style }: SVGProps<SVGSVGElement>) {
  return (
    <img
      src={claudeCodeSrc}
      className={className as string | undefined}
      style={style as CSSProperties | undefined}
      alt=""
      aria-hidden
    />
  );
}
